module.exports = __webpack_public_path__ + "static/media/angellist.280dd548.svg";